<!-- 予約内容入力 -->
<template>
  <TemplateMfittBookingProcessing v-if="isReadyToDraw" />

  <!-- 描画ローディング -->
  <DialogInitialLoading v-else :timeout-seconds="21000" />
</template>

<script>
import { onMounted, ref, computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import TemplateMfittBookingProcessing from "@/views/Templates/MFITT/TemplateMfittBookingProcessing";

import API from "@/API";

import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "MfittBookingProcessing",
  components: {
    TemplateMfittBookingProcessing,
  },
  setup() {
    const store = useStore();
    const route = useRoute();

    const paymentResult = computed(() => store.getters["MFITT/paymentResult"]);

    // ログインしているかどうか
    const isLogin = store.getters["common/isLogin"];

    const isReadyToDraw = ref(false);

    onMounted(async () => {
      if (paymentResult.value.processId) {
        API.getPaymentProcessInfo(paymentResult.value.processId);
      }

      if (!isLogin) {
        // 未ログインの場合はダイアログ
        nativeHandlerService.returnNativeAppToAccountPage();
        // 未ログインのダイアログは、ダイアログ外を押しても閉じてしまうので、対策として10秒後にネイティブに戻る
        setTimeout(nativeHandlerService.returnNativeAppMfittIndexPage, 10000);
      } else {
        isReadyToDraw.value = true;
      }
    });

    return {
      isReadyToDraw,
    };
  },
};
</script>
